import ProjectsPage from './ProjectsPage';

export default ProjectsPage;
